import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

import quoteo from '../../img/icons/quoteo.svg'
import quotec from '../../img/icons/quotec.svg'

const Quote = withStyles(styles)(props => {

  const { classes, quote } = props
  return (
    <div className={classes.quoter}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <img src={quoteo} className={classes.quoterMarkLeft} alt="#" />
              <Typography className={classes.quoterQuote}>
                {quote.quote.text}
              </Typography>
              {
                quote.author &&
                <Typography className={classes.quoterAuthor}>
                  {quote.author.text}
                </Typography>
              }
              {
                quote.company &&
                <Typography className={classes.quoterCompany}>
                  {quote.company.text}
                </Typography>
              }
              <img src={quotec} className={classes.quoterMarkRight} alt="#" />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(Quote)



// WEBPACK FOOTER //
// ./src/components/quote/index.js